const DEFAULT_VIEWPORT_HEIGHT = 900;
const DEFAULT_VIEWPORT_WIDTH = 1440;

export const subscribeToViewportResize = (listener: () => void): (() => void) => {
  if (typeof window === "undefined") {
    return () => undefined;
  }

  window.addEventListener("resize", listener);
  window.visualViewport?.addEventListener("resize", listener);

  return () => {
    window.removeEventListener("resize", listener);
    window.visualViewport?.removeEventListener("resize", listener);
  };
};

export const getViewportHeight = (ratio = 0.7, fallbackHeight = DEFAULT_VIEWPORT_HEIGHT): number => {
  if (typeof window === "undefined") {
    return fallbackHeight;
  }

  const viewportHeight = window.visualViewport?.height ?? window.innerHeight;
  return Math.floor(viewportHeight * ratio);
};

export const getViewportSize = (
  fallbackHeight = DEFAULT_VIEWPORT_HEIGHT,
  fallbackWidth = DEFAULT_VIEWPORT_WIDTH
): {
  height: number;
  width: number;
} => {
  if (typeof window === "undefined") {
    return {
      height: fallbackHeight,
      width: fallbackWidth
    };
  }

  return {
    height: Math.floor(window.visualViewport?.height ?? window.innerHeight),
    width: Math.floor(window.visualViewport?.width ?? window.innerWidth)
  };
};
